import { useEffect } from 'react';
import { serializeError } from 'serialize-error';
import { type ExceptionResponse } from '~/app/api/exceptions/route';

type UseErrorLoggerParams = {
  error?: Error & { digest?: string };
  boundaryLocation?:
    | 'BasketExportedErrorBoundary'
    | 'CheckoutErrorBoundary'
    | 'ErrorBoundary'
    | 'GlobalErrorBoundary'
    | 'StandardLayoutErrorBoundary';
};

export const useErrorLogger = ({
  error,
  boundaryLocation,
}: UseErrorLoggerParams) => {
  useEffect(() => {
    if (!error) return;
    void logErrorToApi({ error, boundaryLocation });
  }, [error, boundaryLocation]);

  return null; // This hook does not return anything, it just logs the error
};

type LogErrorToApiParams = UseErrorLoggerParams;

async function logErrorToApi({ error, boundaryLocation }: LogErrorToApiParams) {
  // Log the error to an error reporting service
  console.error(error);

  try {
    const res = await fetch('/api/exceptions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        boundaryLocation,
        path: window.location.pathname,
        search: window.location.search,
        error: serializeError(error),
      }),
    });

    const data = (await res.json()) as ExceptionResponse;

    if (!res.ok) {
      console.error('Failed to log error:', data);
      return;
    }
    console.log('Error logged successfully:', data);
  } catch (err) {
    console.error('Error logging failed:', err);
  }
}
